import { render, staticRenderFns } from "./swiperOffersMiddle.vue?vue&type=template&id=4df4248f&"
import script from "./swiperOffersMiddle.vue?vue&type=script&lang=js&"
export * from "./swiperOffersMiddle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/work/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4df4248f')) {
      api.createRecord('4df4248f', component.options)
    } else {
      api.reload('4df4248f', component.options)
    }
    module.hot.accept("./swiperOffersMiddle.vue?vue&type=template&id=4df4248f&", function () {
      api.rerender('4df4248f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/swiperOffersMiddle/swiperOffersMiddle.vue"
export default component.exports